module.exports = __webpack_public_path__ + "img/travelplan.e37a928.png";